import { createRouter, createWebHashHistory, RouteRecordRaw, RouterView } from 'vue-router';
import Console from '../views/console/index.vue';
import bill from './bill';
import groupList from '@/views/group/list.vue';
import groupCreate from '@/views/group/create/index.vue';
import to403 from '@/utils/pageView';
import AwsOrder from '@/views/aws/index.vue';
import { useCnSite } from '@/hooks/use-cn-site';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/console/:id',
    name: 'console',
    component: Console,
    children: [
      {
        path: 'overview',
        name: 'overview',
        component: () => import('@/views/overview/index.vue'),
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile/index.vue'),
      },
      {
        path: 'members',
        name: 'members',
        component: () => import('@/views/members/index.vue'),
      },
      {
        path: 'organization',
        name: 'organization',
        component: () => import('@/views/organization/index.vue'),
      },
      {
        path: 'sso-no-permission',
        name: 'ssoNoPermission',
        component: () => import('@/views/sso/NoPermission.vue'),
      },
      bill,
      {
        path: 'aws-order',
        name: 'aws-order',
        component: AwsOrder,
      },
      {
        path: 'guid',
        name: 'guid',
        component: () => import('@/views/guid/index.vue'),
      },
      {
        path: '403',
        name: '403',
        component: () => import('@/views/403/index.vue'),
      },
      {
        path: 'sso-no-permission',
        name: 'ssoNoPermission',
        component: () => import('@/views/sso/NoPermission.vue'),
      },
    ],
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(function (to, from, nuxt) {
  const { cnEdition } = useCnSite();
  const cnAllowedRoutes = ['overview', 'guid', 'profile', 'members', 'organization'];

  // 如果是cnEdition且当前路由不在白名单中，重定向到overview
  if (cnEdition && to.name && !cnAllowedRoutes.includes(to.name as string)) {
    nuxt({ name: 'overview' });
    return;
  }

  if (to403(to.name)) {
    nuxt({ name: 'bill403' });
  } else {
    nuxt();
  }
});

export default router;
